// extracted by mini-css-extract-plugin
export default {"button":"Modal_button__kfofr","buttons":"Modal_buttons__McXAH","buttonsWrapper":"Modal_buttonsWrapper__bUnjB"};